import gql from 'graphql-tag';

export default gql`
query search(
    $_id: ID
    $account_info_type:Int
		$account_info_business_name: String
  ){
    accountInfoList(
        _id :$_id,
        account_info_type: $account_info_type,
        account_info_business_name: $account_info_business_name,
        show_data: 30,
      ) {
      account_info {
        _id
        account_info_email
        account_info_business_name
        account_info_business_type {
          th
        }
        account_info_status
        account_info_phone_number
        account_info_phone_code
      }
      account_business{
        _id
      }
      total_page
    }
  }
`;
